/**
 * MUI's `DateCalendar` (the popup body behind `DatePicker`) defaults to a
 * 320px-wide grid with 36px day cells — comfortably wider than this app's
 * `--ctl-h`-scaled controls, and, anchored under a field near the bottom of
 * a form, wide/tall enough to overflow the viewport. Shrunk to match the
 * app's denser sizing instead.
 */
import type { Components, Theme } from '@mui/material/styles';
import '@mui/x-date-pickers/themeAugmentation';

export const MuiDateCalendar: Components<Theme>['MuiDateCalendar'] = {
	styleOverrides: {
		root: {
			width: 260,
			height: 244,
		},
	},
};

export const MuiPickersDay: Components<Theme>['MuiPickersDay'] = {
	styleOverrides: {
		root: {
			width: 28,
			height: 28,
			fontSize: 'var(--fs-small)',
		},
	},
};

export const MuiDayCalendar: Components<Theme>['MuiDayCalendar'] = {
	styleOverrides: {
		weekDayLabel: {
			width: 28,
			height: 28,
			fontSize: 'var(--fs-small)',
		},
	},
};

export const MuiPickersCalendarHeader: Components<Theme>['MuiPickersCalendarHeader'] =
	{
		styleOverrides: {
			root: {
				minHeight: 32,
				paddingLeft: 'var(--s2)',
				paddingRight: 'var(--s1)',
			},
			label: {
				fontSize: 'var(--fs-body)',
			},
		},
	};
